import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteLabelMutationVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
  labelId: Types.Scalars['ID'];
}>;


export type DeleteLabelMutation = { __typename?: 'Mutation', deleteLabel?: { __typename?: 'DeleteLabelPayload', successful: boolean } | null };

export const DeleteLabelDocument = gql`
    mutation DeleteLabel($poolId: ID!, $labelId: ID!) {
  deleteLabel(poolId: $poolId, labelId: $labelId) {
    successful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLabelGQL extends Apollo.Mutation<DeleteLabelMutation, DeleteLabelMutationVariables> {
    document = DeleteLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }